import { BTPopover } from "@btnet/core-components/BTPopover";

import { type BTSelectItem } from "types/apiResponse/apiResponse";
import { AccountingIntegrationType } from "types/enum";

export const renderRetainageItem = (item: BTSelectItem) => {
    if (!item.disabled) {
        return item.title;
    }
    return (
        <BTPopover
            content={
                "This item can't be linked. In QuickBooks, map it to an income account and make sure it's not set as an inventory type."
            }
            placement="left"
        >
            <span style={{ pointerEvents: "auto" }}>{item.title}</span>
        </BTPopover>
    );
};

export const renderApRetainageItem = (item: BTSelectItem) => {
    if (!item.disabled) {
        return item.title;
    }
    return (
        <BTPopover
            content={
                "This item can't be linked. In QuickBooks, map it to an expense account and make sure it's not set as an inventory type."
            }
            placement="left"
        >
            <span style={{ pointerEvents: "auto" }}>{item.title}</span>
        </BTPopover>
    );
};

export function getAccountingLabelText(
    integrationType: AccountingIntegrationType | null | undefined,
) {
    let label = "";
    switch (integrationType) {
        case AccountingIntegrationType.QuickBooksDesktop:
        case AccountingIntegrationType.QuickBooksOnline:
            label = "QB";
            break;
        case AccountingIntegrationType.Xero:
            label = "Xero";
            break;
        case AccountingIntegrationType.SageIntacct:
            label = "Sage";
            break;
    }
    return label;
}

export function getFullIntegrationName(
    integrationType: AccountingIntegrationType | null | undefined,
) {
    let label = "";
    switch (integrationType) {
        case AccountingIntegrationType.QuickBooksDesktop:
            label = "QuickBooks Desktop";
            break;
        case AccountingIntegrationType.QuickBooksOnline:
            label = "QuickBooks Online";
            break;
        case AccountingIntegrationType.Xero:
            label = "Xero";
            break;
    }
    return label;
}
